<section class="panel data-table">

  <header *ngIf="showTitle" class="panel-heading">
    <h5 class="panel-title" [ngClass]="{'panel-title-displayed' : displayContent}">{{tableTitle | async}}<span *ngIf="loading">Loading...</span></h5>
  </header>

  <div class="data-table widget-content">
    <div class="table-search table-search-hidden" [ngClass]="{'table-search-hidden' : !displayContent}">
      <ng-content select="[search-toolbar]"></ng-content>
      <input #gb class="form-control" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." pInputText type="text">
      <div class="widget-tools btn-group" role="group" aria-label="...">
        <button *ngIf="displayExportButton" alt="Export CSV" (click)="showExportMenu($event)" (contextmenu)="showExportMenu($event)" class="btn btn-default" pButton type="button" icon="fa-fw fa fa-download">Export</button>
        <button *ngIf="displayEditColumnsButton" alt="Edit" (click)="showEditDialog()" class="btn btn-default" pButton type="button" icon="fa-fw fa fa-pencil">Edit</button>
      </div>
    </div>
    <middle-of-page-dotted-spinner [loading]="loading"></middle-of-page-dotted-spinner>
    <div #container class="data-table table-container"  [ngClass]="{'table-container-displayed' : displayContent}">

      <p-table #dt
               exportFilename="export"
               [exportFunction]="exportFunction"
               [value]="table?.Rows"
               [columns]="primeColumns"
               (onFilter)="afterFiltered($event)"
               [rows]="rows"
               [totalRecords]="totalRecords"
               [loading]="loading"
               loadingIcon="fa fa-spinner fa-pulse fa-fw"
               [reorderableColumns]="reorderableColumns"
               [resizableColumns]="resizableColumns"
               [(selection)]="selectedRow"
               (onRowSelect)="rowSelected($event)"
               selectionMode="single"
               sortMode="single"
               (onColReorder)="columnsReordered($event)"
               (onColResize)="columnsResized($event)"
               columnResizeMode="expand"
               [scrollable]="true"
               scrollHeight="flex"
               [paginator]="false"
               [customSort]="customSort"
               (sortFunction)="handleCustomSort($event)"
               (onSort)="handleSort($event)"
               [dataKey]="dataKey"
               [expandedRowKeys]="expandedRowKeys">

        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <ng-container *ngIf="colGroupTemplateRef; then customColGroupTemplate  else defaultColGroupTemplate "></ng-container>
            <ng-template #defaultColGroupTemplate>
              <col *ngFor="let col of columns" [hidden]="col.isSystemColumn">
            </ng-template>
            <ng-template #customColGroupTemplate>
              <ng-container [ngTemplateOutlet]="colGroupTemplateRef" [ngTemplateOutletContext]="{ columns: columns }"></ng-container>
            </ng-template>
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>

          <ng-template #customColumnHeadersLeft>
            <ng-content select="[custom-column-headers-left]"></ng-content>
          </ng-template>

          <ng-template #customColumnHeaders>
            <ng-content select="[custom-column-headers]"></ng-content>
          </ng-template>

          <ng-container *ngIf="isMobile(); else desktop">
            <tr (touchMove)="headerTouched($event)" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="columnsReordered($event)">
              <ng-container *ngTemplateOutlet="customColumnHeadersLeft">
              </ng-container>
              <th cdkDrag *ngFor="let col of columns" [hidden]="col.isSystemColumn" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sortable" pResizableColumn pReorderableColumn>
                {{prepareColumnName(col)}}
                <p-sortIcon *ngIf="col.sortable" [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
              <ng-container *ngTemplateOutlet="customColumnHeaders">
              </ng-container>
            </tr>
          </ng-container>

          <ng-template #desktop>
            <tr>
              <ng-container *ngTemplateOutlet="customColumnHeadersLeft">
              </ng-container>
              <th *ngFor="let col of columns" [hidden]="col.isSystemColumn" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sortable" pResizableColumn pReorderableColumn>
                {{prepareColumnName(col)}}
                <p-sortIcon *ngIf="col.sortable" [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
              <ng-container *ngTemplateOutlet="customColumnHeaders">
              </ng-container>
            </tr>
          </ng-template>

        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr (click)="rowClick(rowData)" [pSelectableRow]="rowData">
            <ng-container *ngIf="rowTemplateRef; then customRowTemplate  else defaultRowTemplate "></ng-container>
            <ng-template #defaultRowTemplate>
              <td *ngFor="let col of columns"
                  [hidden]="col.isSystemColumn"
                  [class.right]="isColumnRightAlign(col.type)"
                  class="ui-resizable-column" >
                {{formatByColumnType(rowData[col.field], col.type)}}
              </td>
            </ng-template>
            <ng-template #customRowTemplate>
              <ng-container [ngTemplateOutlet]="rowTemplateRef" [ngTemplateOutletContext]="{ rowData: rowData, columns: columns }"></ng-container>
            </ng-template>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer" let-columns>
          <ng-container *ngTemplateOutlet="footerTemplateRef; context: {$implicit: columns}"></ng-container>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
          <ng-container [ngTemplateOutlet]="expandedRowTemplateRef"
                        [ngTemplateOutletContext]="{ rowData: rowData, columns: columns }"></ng-container>
        </ng-template>

      </p-table>
    </div>

    <div>
      <mojo-table-paginator #paginator *ngIf="!loading" [rowCountOverride]="rowCountOverride" [table]="dt" [showPaginator]="showPaginator"></mojo-table-paginator>
    </div>
  </div>
</section>

<p-dialog header="Edit Columns" [(visible)]="displayDialog" showEffect="fade" [modal]="true" [closable]="false" appendTo="body">
  <p-multiSelect appendTo="body" [options]="availableColumns" dataKey="Field" [(ngModel)]="selectedColumns" optionLabel="Header" defaultLabel="Choose" selectedItemsLabel="{0} items selected"></p-multiSelect>
  <p-footer>
    <div class="btn-group" role="group" aria-label="...">
      <button type="button" pButton icon="fa-fw fa fa-undo" (click)="reset()">Reset</button>
      <button type="button" pButton icon="fa-fw fa fa-check" (click)="save()">Ok</button>
      <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancel()">Cancel</button>
    </div>
  </p-footer>
</p-dialog>

<p-contextMenu #exportMenu [model]="exportMenuItems" appendTo="body"></p-contextMenu>

